import { render, staticRenderFns } from "./VoiceCommandDisplay.vue?vue&type=template&id=07c055af&scoped=true"
import script from "./VoiceCommandDisplay.vue?vue&type=script&lang=js"
export * from "./VoiceCommandDisplay.vue?vue&type=script&lang=js"
import style0 from "./VoiceCommandDisplay.vue?vue&type=style&index=0&id=07c055af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c055af",
  null
  
)

export default component.exports